import { ReactNode, createContext, useContext } from "react";
import { useForceUpdateServiceWorker } from "./ForceUpdateServiceWorker";
import {
  InstallPromptContext,
  defaultInstallPromptContext,
  useAddToHomescreenPrompt,
} from "./InstallPermission";
import {
  NotificationPermissionContextType,
  defaultNotificationPermission,
  useAskNotificationPermission,
} from "./NotificationPermission";

type BrowserPermissionContext = {
  install: InstallPromptContext;
  notifications: NotificationPermissionContextType;
};

export const BrowserPermissionContext = createContext<BrowserPermissionContext>(
  {
    install: defaultInstallPromptContext,
    notifications: {
      askPermission: async () => {},
      notificationPermissionState: defaultNotificationPermission,
      pushSubscription: null,
      resubscribeUser: async () => {},
    },
  },
);

export const useBrowserPermissionContext = () =>
  useContext(BrowserPermissionContext);

export const BrowserPermissionContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const notificationContext = useAskNotificationPermission();
  const installContext = useAddToHomescreenPrompt();

  useForceUpdateServiceWorker();

  return (
    <BrowserPermissionContext.Provider
      value={{
        install: installContext,
        notifications: notificationContext,
      }}
    >
      {children}
    </BrowserPermissionContext.Provider>
  );
};
